import axios from "axios"
import {PUBLIC_ACTION_TYPES} from "@store/actionTypes/PublicActionTypes"

const API_URL = `${process.env.REACT_APP_BASEURL}`

const headers = {
    Accept: "application/json"
}

export const getCountries = () => async (dispatch) => {
    dispatch({type: PUBLIC_ACTION_TYPES.GET_COUNTRY_REQUEST})
    try {
        const {data} = await axios.get(`${API_URL}get-countries`, {headers})
        dispatch({type: PUBLIC_ACTION_TYPES.GET_COUNTRY_DATA, payload: data})
    } catch (error) {
        dispatch({type: PUBLIC_ACTION_TYPES.GET_COUNTRY_ERROR, payload: error})
    }
}

export const getRegions = (payload) => async (dispatch) => {
    dispatch({type: PUBLIC_ACTION_TYPES.GET_REGION_REQUEST});
    try {
        const {data} = await axios.post(`${API_URL}get-regions`, payload, {headers});
        dispatch({type: PUBLIC_ACTION_TYPES.GET_REGION_DATA, payload: data});
    } catch (error) {
        dispatch({type: PUBLIC_ACTION_TYPES.GET_REGION_ERROR, payload: error});
    }
}

export const getStates = (payload) => async (dispatch) => {
    dispatch({type: PUBLIC_ACTION_TYPES.GET_STATE_REQUEST});
    try {
        const {data} = await axios.post(`${API_URL}get-states`, payload, {headers});
        dispatch({type: PUBLIC_ACTION_TYPES.GET_STATE_DATA, payload: data});
    } catch (error) {
        dispatch({type: PUBLIC_ACTION_TYPES.GET_STATE_ERROR, payload: error});
    }
}

export const getCities = (payload) => async (dispatch) => {
    dispatch({type: PUBLIC_ACTION_TYPES.GET_CITY_REQUEST});
    try {
        const {data} = await axios.post(`${API_URL}cities`, payload, {headers});
        dispatch({type: PUBLIC_ACTION_TYPES.GET_CITY_DATA, payload: data});
    } catch (error) {
        dispatch({type: PUBLIC_ACTION_TYPES.GET_CITY_ERROR, payload: error});
    }
}

export const getRegionsReset = () => async (dispatch) => {
    dispatch({type: PUBLIC_ACTION_TYPES.GET_REGION_RESET})
}

export const getStatesReset = () => async (dispatch) => {
    dispatch({type: PUBLIC_ACTION_TYPES.GET_STATE_RESET})
}

export const getCitiesReset = () => async (dispatch) => {
    dispatch({type: PUBLIC_ACTION_TYPES.GET_CITY_RESET})
}

export const getGoalAttr = () => async (dispatch) => {
    dispatch({type: PUBLIC_ACTION_TYPES.GET_GOAL_ATTR_REQUEST});
    try {
        const {data} = await axios.get(`${API_URL}get-goals-attr`, {headers});
        dispatch({type: PUBLIC_ACTION_TYPES.GET_GOAL_ATTR_DATA, payload: data});
    } catch (error) {
        dispatch({type: PUBLIC_ACTION_TYPES.GET_GOAL_ATTR_ERROR, payload: error});
    }
}